/* eslint-disable no-console */

export default (function () {
  console.log(
    `%c
████████╗███████╗ ██████╗██╗  ██╗██╗███╗   ██╗████████╗
╚══██╔══╝██╔════╝██╔════╝██║  ██║██║████╗  ██║╚══██╔══╝
   ██║   █████╗  ██║     ███████║██║██╔██╗ ██║   ██║   
   ██║   ██╔══╝  ██║     ██╔══██║██║██║╚██╗██║   ██║   
   ██║   ███████╗╚██████╗██║  ██║██║██║ ╚████║   ██║   
   ╚═╝   ╚══════╝ ╚═════╝╚═╝  ╚═╝╚═╝╚═╝  ╚═══╝   ╚═╝  
   ═════════════════════════════════════════════════
   ══════════║ %cEngineering & Construction %c║═════════
   ═════════════════════════════════════════════════

  %cIf you have any technical problems, please contact: c%cazcon@techint.com
                                                       
`,
    "color: #858585;",
    "color: rgb(0, 169, 79)",
    "color: #A4A4A4;",
    "color: black",
    "color: blue",
  );
})();
